export const initialValuesAdd = {
  title: '',
  titleUZ: '',
  titleRU: '',
  titleEN: '',
  desc: '',
  parent: '',
  group: '',
  role: 'editor',
  meet: false,
  public: false,
  webEdit: false,
  special: false,
  regions: [],
  telGroupId: '',
  workStatus: 0,
};

export const workStatusList = [
  { _id: 0, title: 'Вилоят текширади' },
  { _id: 1, title: 'Туман текширади' },
];
export const formData = {
  title: 'Категория қўшиш',
  data: [
    {
      type: 'text',
      label: 'Номи',
      name: 'title',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent', 'child'],
    },
    {
      type: 'text',
      label: 'Номи (Uz)',
      name: 'titleUZ',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['child'],
    },
    {
      type: 'text',
      label: 'Номи (Ru)',
      name: 'titleRU',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['child'],
    },
    {
      type: 'text',
      label: 'Номи (En)',
      name: 'titleEN',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['child'],
    },
    {
      type: 'text',
      label: 'Изоҳ',
      name: 'desc',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent', 'child'],
    },
    {
      type: 'select',
      label: 'Қайси категорияга тегишли',
      name: 'parent',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['child'],
    },
    {
      type: 'select',
      label: 'Объектни танланг',
      name: 'object',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent', 'child'],
    },
    {
      type: 'select',
      label: 'Гуруҳни танланг',
      name: 'group',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent', 'child'],
    },
    {
      type: 'select',
      label: 'Туманни танланг',
      name: 'regions',
      value: '',
      size: 12,
      isShow: ['child'],
      multiple: true,
      permission: ['editor'],
    },
    {
      type: 'select',
      label: 'Баҳоланиши',
      name: 'workStatus',
      value: '',
      size: 12,
      isShow: ['child'],
      permission: ['editor'],
    },
    {
      type: 'text',
      label: 'Телеграм гуруҳ',
      name: 'telGroupId',
      value: '',
      size: 12,
      isShow: ['parent'],
      permission: ['editor'],
    },
    {
      type: 'switch',
      label: 'Видео билан',
      name: 'withVideo',
      value: '',
      size: 12,
      isShow: ['parent', 'child'],
      permission: ['editor'],
    },
    {
      type: 'switch',
      label: 'Тадбир турини кўрсатиш',
      name: 'meet',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent', 'child'],
    },
    {
      type: 'switch',
      label: 'Сайт учун',
      name: 'public',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent'],
    },
    {
      type: 'switch',
      label: 'Вебда таҳрирлаш',
      name: 'webEdit',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['child'],
    },
    {
      type: 'switch',
      label: 'Махсус',
      name: 'special',
      value: '',
      size: 12,
      permission: ['editor'],
      isShow: ['parent'],
    },
  ],
};

export const parentFormData = {
  title: 'Категория қўшиш',

  data: [
    { type: 'text', label: 'Номи', name: 'title', value: '', size: 24 },
    { type: 'text', label: 'Изоҳ', name: 'desc', value: '', size: 24 },
    { type: 'select', label: 'Гуруҳ', name: 'group', value: '', size: 24 },
    {
      type: 'text',
      label: 'Телеграм гуруҳ',
      name: 'telGroupId',
      value: '',
      size: 24,
    },
    {
      type: 'switch',
      label: 'Сайт учун',
      name: 'public',
      value: '',
      size: 12,
    },
    {
      type: 'switch',
      label: 'Махсус',
      name: 'special',
      value: '',
      size: 12,
    },
  ],
};
